import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_addressDisplay = _resolveComponent("addressDisplay")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mt-0",
    style: _normalizeStyle(_ctx.isMobile ? 'padding: 0px 15px' : '')
  }, [
    _createVNode(_component_ion_row, {
      class: "ion-justify-content-center",
      "data-cy": "delivery-unavailable"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, { size: "12" }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "my-0 pb-4 color-black bold" }, "Delivery Unavailable", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "my-8" }, "We currently cannot deliver to:", -1)),
            _createVNode(_component_addressDisplay, {
              address: _ctx.deliveryAddress,
              "data-cy": "delivery-address",
              dense: "",
              showZip: ""
            }, null, 8, ["address"]),
            _cache[4] || (_cache[4] = _createElementVNode("h5", {
              class: "ion-text-center",
              style: {"padding":"15px 0px"}
            }, "Try another address or order pickup", -1)),
            _createVNode(_component_ion_button, {
              expand: "block",
              color: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changePickup')))
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Order Pickup")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 4))
}